module.exports = __webpack_public_path__ + "c0409c9966b22d9d7ad8993a492b05c0.jpg";